import React, { Component } from 'react';
import Icon from '../../../../icons/Icon';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import CustomAnimateButton from '../../../custom/CustomAnimateButton';
import ActionService from '../../../../service/ActionService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import Editor from '@monaco-editor/react';
import FormicaLabel from '../../../custom/FormicaLabel';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../../config/binding/InstanceBinding';
import Injectables from '../../../../constant/Injectables';
import CollectionNames from '../../../../constant/CollectionNames';
import { ActionJsonModel } from '../../../../domain/collection/rule/action/ActionDomains';
import { WatchlistBaseModel, WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from '../../../../domain/watchlist/WatchlistDomains';
import { FormicaProps, withFormica } from '../../../../helpers/withFormica';
import MessageUtil from '../../../../util/MessageUtil';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistAlertActionComponent extends Component<Props, State> {
  public state: State = new State();

  private computation: subscribe.Computation | undefined;
  private actionSubscription: subscribe.Subscription | undefined;

  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private readonly actionService: ActionService = ServiceContainer.getInstance().get(ServiceNames.ACTION);

  public render() {
    const { actionType, loading, response } = this.state;

    return (
      <div className={'flex flex-col w-full h-full overflow-y-scroll py-5 px-5'}>
        <div className={'flex flex-col gap-y-5 justify-start items-center h-full'}>
          <div className={'flex flex-col gap-x-1 w-full'}>
            <FormicaLabel label={'Action'} />
            <FormicaSearchSelectBox
              options={this.getActionOptions()}
              value={actionType}
              onChange={(e: FormicaSelectBoxItem) => this.setState({ actionType: e.value, response: undefined })}
            />
          </div>
          {response ? (
            <Editor options={{ readOnly: true }} className={'max-h-[200px] h-[200px]'} language='json' value={response} />
          ) : !actionType ? (
            'Please select action'
          ) : (
            <CustomAnimateButton
              disabled={loading}
              loading={loading}
              customSize={'md'}
              icon={<Icon icon={'deploy-with-bg'} size={40} />}
              text={LanguageUtil.get({ id: 'common.button.send', defaultMessage: 'Send' })}
              onClick={this.sendAction}
            />
          )}
        </div>
      </div>
    );
  }

  public componentDidMount(): void {
    this.startTracker();
  }

  public async componentWillUnmount() {
    await this.stopTracker();
  }

  private startTracker = (): void => {
    const actionQuery = QueryBuilder.select().from(CollectionNames.ACTIONS).where(eq('type', 'kyc')).select('type', 'id').build();
    this.actionSubscription = subscribe.Formica.subscribe(CollectionNames.ACTIONS, actionQuery);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.actionSubscription]);
  };

  private stopTracker = () => {
    this.actionSubscription?.stop();
    this.computation?.stop();
  };

  private tracker = async () => {
    if (this.actionSubscription?.ready()) {
      const actionQuery = QueryBuilder.select().from(CollectionNames.ACTIONS).where(eq('type', 'kyc')).select('id').build();
      const actions = await this.repository.findMany<ActionJsonModel>(actionQuery);
      this.setState({ actions: actions?.map((action) => action.id!) });
    }
  };

  private sendAction = async () => {
    const { actionType } = this.state;
    const { response, request } = this.props;
    if (actionType && request && response) {
      try {
        const result = await this.actionService.sendKycAction(actionType, request, response);
        if (result) {
          this.setState({ response: JSON.stringify(result, null, 2), loading: false });
          if (result.error) {
            MessageUtil.error({
              summary: 'Send Action',
              detail: <div>Action could not be sent, error was received</div>,
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  private getActionOptions = (): FormicaSelectBoxItem[] => {
    const { actions } = this.state;
    if (actions == undefined) return [];
    return actions.map((action) => ({ label: action, value: action }));
  };
}

interface Props extends FormicaProps {
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest;
  response: WatchlistBaseModel[];
}

class State {
  actions: string[] | undefined;
  actionType: string | undefined;
  response: any;
  loading: boolean = false;
}

export default withFormica(WatchlistAlertActionComponent);
